import { ApolloConsumer } from "@apollo/client";
import React ,{createRef }from "react";
import { browserHistory } from "react-router";
import { dateISOtoUS } from "../../date-converter";
import CRUD from "../CRUD/CRUD";
import { CREATE_OR_UPDATE_CONTACTS_VENDORS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_CONTACT_TEAM_BY_ID, GET_CONTACT_VENDOR_BY_ID, GET_CONTACT_VENDORS_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import VendorCompanyInfo from "./VendorCompanyInfo";
import VendorInfo from "./VendorInfo";
import NotesReusable from "../NotesReusable";
import { sanitizeNotesForInput } from "../../utils";

const priceProps = [
    "price_min",
    "price_max",
];

const dateProps = [
    "last_modified"
];

function parseNumber(data, property) {
    const value = data[property]
    return Number(
      typeof value === "string" ? value.replace(/,/g, "") : value || 0
    );
  }


function convertDataToForm(dbData) {
    const data = { ...dbData };

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                data[key] = num.toLocaleString();
            }
        });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateISOtoUS(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

export default class CRUDVendor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: { contact_type: ["Vendor"] },
            original: null,
            isBusy: null,
            isExists: false,
            users: [],
            error: null,
            success: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            previousStatus: null,
            currentIndex: 0,
            fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
            typeDuplicate:null
        };
        this.client = null;
        this.notesRef = createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.saveData = this.saveData.bind(this);
        this.updateURL = this.updateURL.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.fetch(nextProps.params.id);
        }
    }
    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }
    componentDidMount() {
        if (this.state.fromListUrl) {
            localStorage.setItem('fromListUrl', this.state.fromListUrl);
            this.setState({ fromListUrl: this.state.fromListUrl });
          }
        //#region Below code executes when we click the Last name in MergeDuplicate screen
        const tabParam = this.props.location.query && this.props.location.query.tab;
        if (tabParam && !isNaN(tabParam)) {
            this.setState({ currentTab: parseInt(tabParam.trim(), 10) });
        }
        else {
            this.setState({ currentTab: 0 });
        }
        const queryParams = new URLSearchParams(this.props.location.search);
        queryParams.delete("tab");
        //#endregion

        const hasQuery = queryParams.toString().length > 0;
        if (!hasQuery) {
            this.fetch(this.props.params.id);
          }
          if(hasQuery && !tabParam){
            this.handleQueryChange();
          }
    }
    componentDidUpdate(prevProps) {

        const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
        const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
        if (hasQuery && prevProps.location.search !== this.props.location.search) {
          this.handleQueryChange();
          this.setState({ searchCrudFilter: true });
        }
        // Check if the query has changed
        // if (prevProps.location.search !== this.props.location.search) {
        //   this.handleQueryChange();
        // }
        if(!hasQuery && prevHasQuery){
          this.fetch(this.props.params.id);
          this.setState({ searchCrudFilter: false });
        }
      }

      handleNotesChange(updatedNotes, editId) {
  const cleanedNotes = updatedNotes
    .filter((note) => note.text && note.text.trim() !== "")
    .filter((note) => {
      // Case 1: new note (no arcimedes_row_id)
      if (!note.arcimedes_row_id) return true;

      // Case 2: edited note (arcimedes_row_id matches editId)
      if (editId && note.arcimedes_row_id === editId) return true;

      // Case 3: deleted note
      if (note.deleted === 1) return true;

      // Skip everything else
      return false;
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
         date,
        ...rest
      }) => rest
    );

  this.setState((prev) => ({
    data: {
      ...prev.data,
      notes: cleanedNotes,
    },
  }));
}
      handleQueryChange() {
        const query = this.props.location.query;
        const filterOptions = this.parseFilterOptions(query); 
      
        var isNoFilter = Object.keys(filterOptions).length === 0; 
      
        if (isNoFilter) {
          this.fetch(this.props.params.id);
        }
        else{
          this.fetchWithFilter(filterOptions)
        }
      }
fetchWithFilter(filterOptions) {
  this.setState({
    data: null,
    error: null,
    success: null,
  });

  fetchData(GET_CONTACT_VENDORS_LIST_QUERY, { type:"Vendor",filters:filterOptions})
        .then(res => {
          const filterData = res.data.getContacts.data|| [];
          if(filterData.length > 0){
            this.setState({
              // items: res.data.getCompanies.data,
              // totalCount: res.data.getCompanies.totalCount,
              // error: null,
              // isBusy: null,
              filterData,
              currentIndex:0,
              data:  filterData[0],
              original: { ...filterData[0] },
              error: null,
            },() => {
              this.updateURL(filterData[0]);
            });
          }else {
            this.setState({
              filterData: [],
              data: false,
              error: "No filtered data found. Please try again with different filters.",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
    
}
    fetch(id) {
        if (this.client) {
            this.setState({
                data: null,
                error: null,
                success: null,
            });

            if (id === undefined) {
                this.setState({
                    data: { contact_type: ["Vendor"] },
                    original: {}
                });
                return;
            }
            const token = localStorage.getItem('authToken');
            
            fetchData(GET_CONTACT_VENDOR_BY_ID, { contactid: Number(id) })
            .then((res) => {
                if (res && res.data && res.data.getContactByContactid.contact) {
                    // this.setState({
                        
                    //     data: convertDataToForm(res.data.getContactByContactid.contact),
                    //     original: { ...convertDataToForm(res.data.getContactByContactid.contact) },
                    //     error: null,
                    // });
                    let data = res.data.getContactByContactid.contact;
                    data.contact_type = data.contact_type && data.contact_type.join(",");
                    this.setState({
                        data: data,
                        original: { ...data },
                        error: null,
                    });
                } else {
                    this.setState({
                        data: false,
                        error: res.errors ? res.errors[0].message : "Unidentified Error",
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    data: false,
                    error: error.message || "Unidentified Error",
                });
            });
        }
    }
    async handleSubmit(client, e) {
        e.preventDefault();
        this.setState({
            isExists:false,
            typeDuplicate:null
          });
        if (this.state.viewMode) this.setState({ viewMode: false });
         if (this.notesRef.current && this.notesRef.current.validateNotes) {
           const isValid = this.notesRef.current.validateNotes();
           if (!isValid) {
             console.log("Stop submit: notes invalid");
             return;
           }
         }
        if (!this.state.data.first_name ||
            !this.state.data.last_name) {
            this.setState({ errorTabs: [0], success: null });
            return;
        } else {
            // if (this.state.isBusy || this.state.viewMode === true) return;
            if (this.state.viewMode === true) return;

            this.setState({ errorTabs: [] });

            // this.fetchUserData(0);
            // const isDuplicate = await this.fetchUserData(client);
            // if (isDuplicate) {
            //     console.log("Duplicate entry detected.");
            //     return;
            // }
            if (!this.props.params.id) {
                var pageParams = {
                    page: 1,
                    pageSize: 50
                }
                const token = localStorage.getItem('authToken');
                
                
                if (client) {
                    const input = {
                        
                        contact_type: this.state.data.contact_type.length > 1 ?  this.state.data.contact_type.split(",") : ["Vendor"],
                        vendor_type: this.state.data.vendor_type ? this.state.data.vendor_type : null,
                        first_name: this.state.data.first_name ? this.state.data.first_name : null,
                        last_name: this.state.data.last_name ? this.state.data.last_name : null,
                        phone: this.state.data.phone ? this.state.data.phone : null,
                        cell_phone: this.state.data.cell_phone ? this.state.data.cell_phone : null,
                        email: this.state.data.email ? this.state.data.email : null,
                        notes: sanitizeNotesForInput(this.state.data.notes),

                        company_name: this.state.data.company_name ? this.state.data.company_name : null,
                        company_address: this.state.data.company_address?  this.state.data.company_address : null,
                        company_city: this.state.data.company_city ? this.state.data.company_city : null,
                        company_state: this.state.data.company_state ? this.state.data.company_state : null,
                        company_zip: this.state.data.company_zip ? this.state.data.company_zip : null,
                        website: this.state.data.website ? this.state.data.website:'' ,
                        deleted: this.state.data.deleted ? this.state.data.deleted : null,
                    }
                    
                    try {
                        const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_VENDORS,  {
                            input :input
                         },)
                        
                        if (res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.success) {
                            this.setState({
                                isBusy: false,
                                success: "Saved",
                                viewMode: true
                            }, () => {
                                if (!this.props.edit) {
                                    browserHistory.push({
                                        // pathname: `/buyer/${res.data.createOrUpdateBuyer.buyer.arcimedes_row_id}`,
                                        pathname: `/vendor/${res.data.createOrUpdateContact.contact.contact_id}`,
                                    });
                                }
                            });

                            window.scrollTo(0, 0);
                        }else if( res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error && res.data.createOrUpdateContact.error.includes("already exists"))
                            {
                                this.setState({
                                    isExists:true,
                                    typeDuplicate: res.data.createOrUpdateContact.error,
                                viewMode:false})
                            
                          }else {
                            this.setState({
                                isBusy: null,
                                data: null,
                                original: null,
                                error: res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error ? res.data.createOrUpdateContact.error : "Unspecified error",
                            });
                        }

                    } catch (error) {
                        console.error("Error in handleSubmit:", error);
                    }
                }

            }
            else {
                this.setState({ viewMode: true }, () => this.saveData(client));
            }
        }
    }

    handleChangeInput(key, value) {
        this.setState(prevState => ({
            data: {
                ...prevState.data,
                [key]: value
            }
        }));
    }

    handleChangeDropdown(query, queryType, x, key) {
        const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());

    if (key === "contact_type" && (userContactTypes.length > 1 || query.contact_type === "Vendor") && this.state.typeDuplicate) {
      const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
      const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

      const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
      if (!hasMatch) {
        this.setState({
          isExists: false,
          typeDuplicate: null,
          isBusy: false,
        });
      }
    }
        const data = { ...this.state.data };
        data[key] = query[key];
        this.setState({ data });
    }

    async saveData(client) {
        
        // if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        Object.keys(this.state.data).forEach((k) => {
            if (!this.state.data[k] || k === "undefined") {
                const newData = { ...this.state.data };
                delete newData[k];
                this.setState({ data: newData });
            }
        });

        var pageParams = {
            page: 1,
            pageSize: 50
        }
        
const input = {
    // contact_type:"Buyer",
    contact_type: this.state.data.contact_type.length > 1 ?  this.state.data.contact_type.split(",") : ["Vendor"],
    name:this.state.data.contact_type.includes("Lender") ? this.state.data.name : "",
    // lenderNotes: this.state.data.contact_type.includes("Lender") ? this.state.data.lenderNotes : "",
    contact_id: this.props.params.id ? Number(this.props.params.id) : null,
    phone: this.state.data.phone ? this.state.data.phone : null,
    cell_phone: this.state.data.cell_phone ? this.state.data.cell_phone : null,
    company_address: this.state.data.company_address ? this.state.data.company_address : null,
    company_city: this.state.data.company_city ? this.state.data.company_city : null,
    company_name: this.state.data.company_name ? this.state.data.company_name : null,
    company_state: this.state.data.company_state ? this.state.data.company_state : null, 
    company_zip: this.state.data.company_zip ? this.state.data.company_zip : null,
    deleted: this.state.data.deleted ? this.state.data.deleted : null,
    email: this.state.data.email ? this.state.data.email : null,
    first_name: this.state.data.first_name ? this.state.data.first_name : null,
    last_name: this.state.data.last_name ? this.state.data.last_name : null,
    notes: sanitizeNotesForInput(this.state.data.notes),
    phone: this.state.data.phone ? this.state.data.phone : null,
    vendor_type:this.state.data.vendor_type ? this.state.data.vendor_type : null,
    website: this.state.data.website ? this.state.data.website : '',
}
        try {
            Promise.all([
                
                mutateData(CREATE_OR_UPDATE_CONTACTS_VENDORS,  {
                    input :input
                 },),
                
                fetchData(GET_CONTACT_TEAM_BY_ID, { contactid : this.state.data.strive_agent ? Number(this.state.data.strive_agent) : null })
            ])
            .then((res) => {
                
                let previousStatus;
                if (res && res[0].data && res[0].data.createOrUpdateContact && res[1].data && res[1].data.getContactByContactid) {
                    const buyerData = res[0].data.createOrUpdateContact.contact;
                    //previousStatus = this.state.original.status; //it should be there but i removed to get saved on UI screen when we edit and save
                    this.setState({
                        isBusy: false,
                        success: "Saved",
                        original: buyerData,
                    }, () => {
                        if (!this.props.edit) {
                            browserHistory.push({
                                // pathname: `/buyer/${res.data.createOrUpdateBuyer.buyer.arcimedes_row_id}`,
                                pathname: `/vendor/${res[0].data.createOrUpdateContact.contact.contact_id}`,
                            });
                        }
                    });

                    window.scrollTo(0, 0);
                    // const responseDetails = {
                    //     success: true,
                    //     previousStatus,
                    //     status: buyerData.status,
                    //     category: capitalizeAll(buyerData.category),
                    //     type: formatType(buyerData.type),
                    //     market: capitalizeAll(buyerData.market),
                    //     tenant_subcategory: buyerData.type === "MT" ? addSpaceAfterComma(buyerData.multi_tenant_subcategory) : buyerData.type === "STNL" ? addSpaceAfterComma(buyerData.single_tenant_subcategory) : null,
                    //     price_min: buyerData.price_min,
                    //     price_max: buyerData.price_max,
                    //     cap_rate_min: buyerData.cap_rate_min,
                    //     cap_rate_max: buyerData.cap_rate_max,
                    //     notes: buyerData.notes,
                    //     strive_agent: res[1].data.getTeam && res[1].data.getTeam.length ? formatName(res[1].data.getTeam) : null,
                    //     LINK: `${url}vendors?first_name=${buyerData.first_name}&last_name=${buyerData.last_name}`
                    // };

                    // if (responseDetails.success && responseDetails.status === '1031-Buyer') {
                    //     sendBuyerEmail(responseDetails);
                    // }
                    // if (responseDetails.success && !responseDetails.previousStatus && responseDetails.status === 'Active') {
                    //     sendBuyerEmail(responseDetails);
                    // }

                } else if( res && res[0].data && res[0].data.createOrUpdateContact && res[0].data.createOrUpdateContact.error && res[0].data.createOrUpdateContact.error.includes("already exists"))
                    {
                        this.setState({
                            isExists:true,
                            typeDuplicate: res[0].data.createOrUpdateContact.error,
                        viewMode:false})
                    
                  }else {
                    this.setState({
                        isBusy: null,
                        data: null,
                        original: null,
                        error: res && res.errors && res.errors[0] ? res.errors[0].message : "Unspecified error",
                    });
                }
            })
        } catch (error) {
            console.error("Error in saveData:", error);
            this.setState({
                isBusy: false,
                data: null,
                error: error.message || "Unspecified error",
                original: null
            });
        }
    }
 updateURL(data) {
    const queryParams = new URLSearchParams(this.props.location.search);
    // const name = queryParams.get("name");
    // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
    const newUrl = `/vendor/${data.contact_id}?${queryParams.toString()}`;
    browserHistory.push(newUrl);
  }

    render() {
        const data = this.state.data;
        const { edit, isSuper } = this.props;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) this.client = client;
                    return (
                      <CRUD
                        tabsData={[
                          {
                            name: "Vendor",
                            renderedComponent: (
                              <VendorInfo
                                isExists={this.state.isExists}
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.deleted === "1"}
                                handleParentDropdownChange={
                                  this.handleChangeDropdown
                                }
                                typeDuplicate={this.state.typeDuplicate}
                              />
                            ),
                          },
                          {
                            name: "Vendor Company",
                            renderedComponent: (
                              <VendorCompanyInfo
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.deleted === "1"}
                              />
                            ),
                          },
                          {
                            name: "NOTES",
                            renderedComponent: (
                              <NotesReusable
                              data={data}
                                notes={data && data.notes ? data.notes : []}
                                contact_id={
                                  data && data.contact_id
                                    ? data.contact_id
                                    : null
                                }
                                viewMode={this.state.viewMode}
                                handleChangeInput={this.handleChangeInput}
                                ref={this.notesRef}
                                //deleted={data && data.DELETED === "1"}
                                deleted={data && data.deleted === "1"}
                                setState={this.setState.bind(this)}
                                onNotesChange={this.handleNotesChange}
                                state={this.state}
                              />
                            ),
                          },
                        ]}
                        backLink={`${arc.path.base}contacts/vendors`}
                        edit={edit}
                        state={this.state}
                        setState={this.setState.bind(this)}
                        handleSubmit={this.handleSubmit.bind(this, client)}
                        saveData={() => this.saveData(client)}
                        type="vendor"
                        backName="VENDORS"
                        title={data && `${data.first_name} ${data.last_name}`}
                        isSuper={isSuper}
                        filterData={this.state.filterData}
                        currentIndex={this.state.currentIndex}
                        updateURL={this.updateURL}
                        // backToUrl={"/agents"}
                        backToUrl={
                          this.state.fromListUrl
                            ? this.state.fromListUrl
                            : "/vendors"
                        }
                      />
                    );
                }}
            </ApolloConsumer>

        );
    }
}

